import { render } from "./ElectionAuthView.vue?vue&type=template&id=b236557c"
import script from "./ElectionAuthView.vue?vue&type=script&lang=js"
export * from "./ElectionAuthView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__